import { useMutation } from 'react-query';

import { exportSchedulingResultsAsFile as mutationFn } from 'api/endPoints/exportSchedulingResultsAsFile';

export const useMutationDownloadSimulatedVersion = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    metaDataId: number;
    key: string;
    exportTypeRequest: string;
    fileName: string;
    simulationDate: number;
}
